import React from "react";
import withRoot from "../withRoot";
import { withStyles } from "@material-ui/core/styles";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { connect } from "react-redux";
import compose from 'recompose/compose';

import Step1 from '../components/Steps/Step1';
import Step2 from '../components/Steps/Step2';
import Step3 from '../components/Steps/Step3';
import Step4 from '../components/Steps/Step4';
import Step5 from '../components/Steps/Step5';
import Step6 from '../components/Steps/Step6';

import { goNextStep, goBackStep, goFirstStep, goToStep, changeMode, resetTerminalSwitchState, loadOldTerminal, loadNewTerminal, submitTerminalSwitch } from "../actions/terminalSwitchActions";


const styles = theme => ({
  root: {
    padding: 16,
    margin: 16
  },
  stepContainer: {
    margin: 16,
    padding: 16,
    minWidth: 320,
    width: 350,
    maxWidth: 350
  },
  buttonWrapper: {
    marginTop: 15,
    marginBottom: 15,
    textAlign: 'center'
  },
  stepButton: {
    width: "100%"
  },
  stepTitle: {
    marginBottom: 15
  },
});

const maxSteps = 6;

function getSteps() {
  let steps = [];
  // Step UI labels.
  for (let i = 0; i < maxSteps; i++) {
    steps.push('');
  }
  return steps;
}

class TerminalSwitchPage extends React.Component {
  componentDidMount() {
    const { activeStepState, oldTerminal, newTerminal } = this.props;
    if (activeStepState.activeStepNum !== 0 || activeStepState.activeStepMode !== 0 || oldTerminal.terminalData !== null || newTerminal.terminalData !== null) {
      this.handleReset();
    }
  }


  getStepContent = (step) => {
    const { handleNext, handleBack, handleGetOldTerminal, handleGetNewTerminal, handleChangeMode, handleSubmitTerminalSwitch, handleReset, handleGoToStart} = this;
    const { oldTerminal, newTerminal, activeStepState, submitState, classes} = this.props;

    switch (step) {
      case 0:
        // Step 1: Instructions and either take a photo of QR code or begin typing ID of old terminal
        return <Step1 handleNext={handleNext} handleReset={handleReset} mainClasses={classes}/>;
      case 1:
        // Step 2: Take a photo of QR code or type ID of old terminal
        return <Step2 oldTerminal={oldTerminal} handleNext={handleNext} handleBack={handleBack} modeNum={activeStepState.activeStepMode} handleGetOldTerminal={handleGetOldTerminal} mainClasses={classes} handleChangeMode={handleChangeMode}/>;
      case 2:
        // Step 3: Information of old terminal and either take a photo of QR code or begin typing ID of new terminal
        return <Step3 handleNext={handleNext} handleBack={handleBack} oldTerminalData={oldTerminal.terminalData} mainClasses={classes} />;
      case 3:
        // Step 4: Take a photo of QR code or type ID of new terminal
        return <Step4 newTerminal={newTerminal} handleNext={handleNext} handleBack={handleBack} modeNum={activeStepState.activeStepMode} handleGetNewTerminal={handleGetNewTerminal} mainClasses={classes} handleChangeMode={handleChangeMode} />;
      case 4:
        // Step 5: Summary of old and new terminal, approving of terminal switch
        return <Step5 handleSubmitTerminalSwitch={handleSubmitTerminalSwitch} handleBack={handleBack} oldTerminalData={oldTerminal.terminalData} newTerminalData={newTerminal.terminalData} submitState={submitState} mainClasses={classes} />;
      case 5:
        // Step 6: Finished
        return <Step6 handleGoToStart={handleGoToStart} mainClasses={classes} />;
      default:
        return 'Unknown step';
    }
  }

  handleGetOldTerminal = (terminalCode) => {
    const { loadOldTerminal } = this.props;
    if (terminalCode && !isNaN(terminalCode)) {
      loadOldTerminal(terminalCode);
    }
  }

  handleGetNewTerminal = (terminalCode) => {
    const { loadNewTerminal } = this.props;
    if (terminalCode && !isNaN(terminalCode)) {
      loadNewTerminal(terminalCode);
    }
  }

  handleSubmitTerminalSwitch = () => {
    let oldTerminalCode = this.props.oldTerminal.terminalData.terminalCode;
    let newTerminalCode = this.props.newTerminal.terminalData.terminalCode;
    
    const { submitTerminalSwitch } = this.props;
    if (oldTerminalCode && newTerminalCode) {
      submitTerminalSwitch(oldTerminalCode, newTerminalCode);
    }
  }

  // This method changes the next step in UI
  handleNext = (modeNum) => {
    this.props.goNextStep(modeNum);
  };

  // This method resets terminal switch completely
  handleReset = () => {
    this.props.resetTerminalSwitchState();
  };

  // This method changes the previous step in UI
  handleBack = () => {
    this.props.goBackStep();
  };

  // This step will go to wanted step and mode
  handleGoToStep = (stepNum, stepMode) => {
    this.props.goToStep(stepNum, stepMode);
  };
  

  // This method starts from the beginning (first step, that is)
  handleGoToStart = () => {
    this.props.goFirstStep();
  };

  handleChangeMode = () => {
    this.props.changeMode();
  }

  render() {
    const { classes, activeStepState } = this.props;
    const steps = getSteps();
    

    return (
        <Grid container alignItems="center" justify="center">
          <Grid item>
            <Paper className={classes.stepContainer} >
              <Grid container>
                <Grid item xs={12}>
                  <Stepper activeStep={activeStepState.activeStepNum}>
                    {steps.map((label, index) => {
                      const props = {};
                      const labelProps = {};
                      return (
                        <Step key={label} {...props}>
                          <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </Grid>
                <Grid item xs={12}>
                  {this.getStepContent(activeStepState.activeStepNum)}
                </Grid>      
                {/* <StepButtons handleNext={this.handleNext} handleBack={this.handleBack} activeStep={activeStep} steps={steps} /> */}
             </Grid>
            </Paper>
          </Grid>
        </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    oldTerminal: state.terminalSwitch.oldTerminal,
    newTerminal: state.terminalSwitch.newTerminal,
    activeStepState: state.terminalSwitch.activeStepState,
    submitState: state.terminalSwitch.submitState
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goNextStep: (activeStepMode) => {
      dispatch(goNextStep(activeStepMode))
    },
    goBackStep: () => {
      dispatch(goBackStep())
    },
    goFirstStep: () => {
      dispatch(goFirstStep())
    },
    goToStep: (stepNum, stepMode) => {
      dispatch(goToStep(stepNum, stepMode));
    },
    changeMode: () => {
      dispatch(changeMode())
    },
    resetTerminalSwitchState: () => {
      dispatch(resetTerminalSwitchState())
    },
    loadOldTerminal: (terminalCode) => {
      dispatch(loadOldTerminal(terminalCode))
    },
    loadNewTerminal: (terminalCode) => {
      dispatch(loadNewTerminal(terminalCode))
    },
    submitTerminalSwitch: (oldTerminalCode, newTerminalCode) => {
      dispatch(submitTerminalSwitch(oldTerminalCode, newTerminalCode))
    }
  }
}


export default 
withRoot(compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(TerminalSwitchPage));




// WEBPACK FOOTER //
// ./src/containers/TerminalSwitchPage.js